module.exports = __webpack_public_path__ + "static/media/customer.c285bc3b.svg";